
import wixWindow from 'wix-window';
$w.onReady(function () {

    if (wixWindow.multilingual.currentLanguage ===  'he') {
        $w('#airlineENG').hide();
        $w('#airlineHEB').show();
        $w('#sealineENG').hide();
        $w('#sealineHEB').show();
        $w('#cuslineENG').hide();
        $w('#cuslineHEB').show();
        $w('#landlineENG').hide();
        $w('#landlineHEB').show();
        $w('#extlineENG').hide();
        $w('#extlineHEB').show();
    } else {
        $w('#airlineHEB').hide();
        $w('#airlineENG').show();
        $w('#sealineHEB').hide();
        $w('#sealineENG').show();
        $w('#cuslineHEB').hide();
        $w('#cuslineENG').show();
        $w('#landlineHEB').hide();
        $w('#landlineENG').show();
        $w('#extlineHEB').hide();
        $w('#extlineENG').show();
    }
});

$w.onReady(function () {
    if (wixWindow.multilingual.currentLanguage ===  'he') {
        $w('#menuENG').hide();
        $w('#menuHEB').show();
    } else {
        $w('#menuHEB').hide();
        $w('#menuENG').show();
    }
});




$w.onReady( function() {
	$w('#MainSlideshow').play();
} );

export function ButtonAir_click(event) {
	$w('#MainSlideshow').changeSlide(0);
}

export function ButtonCustoms_click(event) {
	$w('#MainSlideshow').changeSlide(2);
}

export function ButtonSea_click(event) {
	$w('#MainSlideshow').changeSlide(1);
}

export function ButtonInland_click(event) {
	$w('#MainSlideshow').changeSlide(3);
}

export function ButtonServices_click(event) {
	$w('#MainSlideshow').changeSlide(4);
}


export function columnStrip2_viewportEnter(event) {
 //Add your code for this event here: 
let startNum = 1900;
let endNum = 2012;
const duration =  50; // 1000 milliseconds 

$w.onReady(function () {
    setInterval(()=> {
        countUp();  
    }, duration);
});

function countUp(){ 
 if (startNum <= endNum ){   
        $w('#text7').text =  startNum.toString();
        startNum++;
    }
}


    let startNum1 = 0;
let endNum1 = 1200;
const duration1 =  5; 

$w.onReady(function () {
    setInterval(()=> {
        countUp1();     
    }, duration1);
});

function countUp1(){    
    if (startNum1 <= endNum1 ){
        $w('#text10').text = startNum1.toString();
        startNum1++;
    }
}

    let startNum2 = 0;
let endNum2 = 100;
const duration2 =  50; 

$w.onReady(function () {
    setInterval(()=> {
        countUp2();     
    }, duration2);
});

function countUp2(){    
    if (startNum2 <= endNum2 ){
        $w('#text5').text =  (startNum2.toString())+"%";
        startNum2++;
    }
}

    let startNum3 = 0;
let endNum3 = 24;
const duration3 =  250; 

$w.onReady(function () {
    setInterval(()=> {
        countUp3();     
    }, duration3);
});

function countUp3(){    
    if (startNum3 <= endNum3 ){
        $w('#text8').text =  (startNum3.toString());
        startNum3++;
    }
}
}
